// PWA bootstrap: registers the service worker after the page has loaded so it
// never blocks first paint. Safe to import from src/index.js.
export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Only register on secure contexts (localhost or https).
  const isSecure = window.isSecureContext || window.location.hostname === 'localhost';
  if (!isSecure) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch(() => {
        /* SW registration failure is non-fatal — app still works. */
      });
  });
}
